import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from '../../app/appSettings';
import { Storage } from '@ionic/storage-angular';
import moment from 'moment';
import { Appointement, Doctor, Patient, Practice, Spec, Message, Med } from '../../providers/content-provider/data-objects';



@Injectable()
export class StorageManager {
    DEBUG = AppSettings.DEBUG;
    TAG = 'StorageManager';
    loggedIn: boolean = false;
    token: string = "";
    tokenExpire: number = 0;
    refreshObservable: any = null;

    constructor(public storage: Storage) {
        this.storage.create();
        this.storage.get("cache_version").then((result) => {
            if (parseInt(result) != AppSettings.CACHE_VERSION) {
                if (AppSettings.CACHE_CLEAR_INSTRUCTION == 0) {
                    if (this.DEBUG) console.log(this.TAG, 'constructor soft clear');
                    this.removeDataButAccount().then((result) => {
                        this.storage.set("cache_version", AppSettings.CACHE_VERSION);
                    });

                } else if (AppSettings.CACHE_CLEAR_INSTRUCTION == 1) {
                    if (this.DEBUG) console.log(this.TAG, 'constructor hard clear');
                    this.storage.clear().then((result) => {
                        this.storage.set("cache_version", AppSettings.CACHE_VERSION);
                    });

                } else {
                    this.storage.set("cache_version", AppSettings.CACHE_VERSION);
                }
            }
        });
    }

    async ngOnInit() {
        // If using a custom driver:
        // await this.storage.defineDriver(MyCustomDriver)
        await this.storage.create();
      }

    set(type, id, data, expiration = 0): Promise<any> {
        if (this.DEBUG) console.log(this.TAG, 'set', type, id, data, expiration);

        //default expiration is 0; if 0 -> get predefinded expiration intervals
        if (expiration === 0) {
            switch (type) {
                case "doc":
                    expiration = AppSettings.EXPIRATION_INTERVAL_DOC;
                    break;
                case "doc_open_apps":
                    expiration = AppSettings.EXPIRATION_INTERVAL_DOC_OPEN_APPS;
                    break;
                case "praxis":
                    expiration = AppSettings.EXPIRATION_INTERVAL_PRAXIS;
                    break;
                case "search":
                    expiration = AppSettings.EXPIRATION_INTERVAL_SEARCH;
                    break;
                case "key":
                    expiration = AppSettings.EXPIRATION_INTERVAL_REFRESH_TOKEN;
                    break;
                case "med":
                    expiration = AppSettings.EXPIRATION_INTERVAL_MED;
                    break;
                case "patient":
                    expiration = AppSettings.EXPIRATION_INTERVAL_PATIENT;
                    break;
                case "patient_history":
                    expiration = AppSettings.EXPIRATION_INTERVAL_PATIENT_HISTORY;
                    break;
                case "patient_freq_docs":
                    expiration = AppSettings.EXPIRATION_INTERVAL_PATIENT_FREQUENT_DOCS;
                    break;
                case "patient_open_apps":
                    expiration = AppSettings.EXPIRATION_INTERVAL_PATIENT_OPEN_APPS;
                    break;
                case "patient_messages":
                    expiration = AppSettings.EXPIRATION_INTERVAL_PATIENT_MESSAGES;
                    break;
                case "specs":
                    expiration = AppSettings.EXPIRATION_INTERVAL_SPECS;
                    break;
                case "specs-used":
                    expiration = AppSettings.EXPIRATION_INTERVAL_SPECS;
                    break;
                    case "topspecs":
                    expiration = AppSettings.EXPIRATION_INTERVAL_SPECS;
                    break;
                case "event":
                    expiration = AppSettings.EXPIRATION_INTERVAL_EVENT;
                    break;
                case "persistent":
                    expiration = AppSettings.EXPIRATION_INTERVAL_NEVER;
                    break;
                case "app":
                    expiration = AppSettings.EXPIRATION_APP;
                    break;
                case "impressum":
                    expiration = AppSettings.EXPIRATION_APP;
                    break;
                // case "reasons":
                //     expiration = AppSettings.EXPIRATION_APP;
                //     break;
                case "geocode":
                    expiration = AppSettings.EXPIRATION_INTERVAL_NEVER;
                    break;
                default:
                    expiration = AppSettings.EXPIRATION_INTERVAL_DEFAULT;
                    break;
            }
        }
        //prepare for storage
        let keys = this.getKeysForStorage(type, id);
        let expTS = this.getCurTS() + expiration;
        //store
        return Promise.all([this.storage.set(keys[0], data),
        this.storage.set(keys[1], expTS)
        ]);
    }

    remove(type, id): void {
        if (this.DEBUG) console.log(this.TAG, 'remove', type, id);

        let keys = this.getKeysForStorage(type, id);
        this.storage.remove(keys[0]).then((result) => {
        });
        this.storage.remove(keys[1]).then((result) => {
        });
    }

    removePrivateData(keysIncluded: boolean = false): Promise<any> {
        if (this.DEBUG) console.log(this.TAG, 'removePrivateData');
        var keysToDelete = [];
        return this.storage.forEach(function (value, key, iterationNumber) {
            if ((key.indexOf('patient_') != -1) || ((key.indexOf('key_') != -1) && keysIncluded)) {
                keysToDelete.push(key);
            }
        }).then(() => {
            var deletePromises = [];
            for (var i = keysToDelete.length - 1; i >= 0; i--) {
                deletePromises.push(this.storage.remove(keysToDelete[i]));
            }
            return Promise.all(deletePromises);
        });
    }

    removeDataButAccount(): Promise<any> {
        if (this.DEBUG) console.log(this.TAG, 'removeDataButAccount');
        var keysToDelete = [];
        return this.storage.forEach(function (value, key, iterationNumber) {
            if (key.indexOf('AccMng_') == -1 && key.indexOf('key_') == -1 && key.indexOf('persistent_') == -1) {
                keysToDelete.push(key);
            }
        }).then(() => {
            var deletePromises = [];
            for (var i = keysToDelete.length - 1; i >= 0; i--) {
                deletePromises.push(this.storage.remove(keysToDelete[i]));
            }
            return Promise.all(deletePromises);
        });
    }

    removeMessages(): Promise<any> {
        if (this.DEBUG) console.log(this.TAG, 'removeMessages');
        return this.storage.remove("patient_messages_0");
    }

    saveMessages(messages): void {
        if (this.DEBUG) console.log(this.TAG, 'saveMessages', messages);
        this.storage.get("patient_messages_0").then((result) => {
            if (result === null || result == 'undefined' || result === undefined || result === '') {
                this.storage.set("patient_messages_0", JSON.stringify(messages));
            } else {
                let oldmessages: Array<Message> = JSON.parse(result).map((app: any) => {
                    return new Message(app);
                });
                for (var i = 0; i < messages.length; ++i) {
                    let exists = false;
                    for (var t = 0; t < oldmessages.length; ++t) {
                        if (messages[i].id == oldmessages[t].id) {
                            exists = true;
                        }
                    }
                    if (!exists) {
                        oldmessages.push(messages[i]);
                    }
                }
                this.storage.set("patient_messages_0", JSON.stringify(oldmessages));
            }
        });

    }

    //get data from storage
    getFromStorage(type, id): Observable<any> {
        if (this.DEBUG) console.log(this.TAG, 'getFromStorage', type, id);

        let keys = this.getKeysForStorage(type, id);

        return Observable.create(observer => {
            this.storage.get(keys[0]).then((result) => {
                if (this.DEBUG) console.log(this.TAG, 'getFromStorage', type, id, 'result:', result);

                if (result === null || result == 'undefined' || result === undefined || result === '') {
                    observer.next(null);
                    //try to delete all data of corrupted data set
                    if (this.DEBUG) console.log(this.TAG, 'key ' + keys[0] + ' is not availible in storage - result is null');
                    this.remove(type, id);
                } else {
                    if (type == "doc") {
                        observer.next(new Doctor(JSON.parse(result)));
                    } else if (type == "event") {
                        observer.next(new Appointement(JSON.parse(result)));
                    } else if (type == "praxis") {
                        observer.next(new Practice(JSON.parse(result)));
                    } else if (type == "app") {
                        observer.next(JSON.parse(result));
                    } else if (type == "impressum") {
                        observer.next(JSON.parse(result));
                    // } else if (type == "reasons") {
                    //     observer.next(JSON.parse(result));
                    } else if (type == "patient_open_apps") {
                        observer.next(JSON.parse(result).map((app: any) => {
                            return new Appointement(app);
                        }));
                    } else if (type == "patient_messages") {
                        observer.next(JSON.parse(result).map((app: any) => {
                            return new Message(app);
                        }));
                    } else if (type == "patient_history") {
                        observer.next(JSON.parse(result).map((app: any) => {
                            return new Appointement(app);
                        }));
                    } else if (type == "med") {
                        observer.next(new Med(JSON.parse(result)));
                    } else if (type == "patient_freq_docs") {
                        observer.next(JSON.parse(result).map((doc: any) => {
                            return new Doctor(doc);
                        }));
                    } else if (type == "patient") {
                        observer.next(new Patient(JSON.parse(result)));
                    } else if (type == "patient_bmp") {
                        observer.next(JSON.parse(result));
                    } else if (type == "patient_bmp_barcode") {
                        observer.next(JSON.parse(result));
                    } else if (type == "geocode") {
                        observer.next(JSON.parse(result));
                    } else if (type == "specs") {
                        observer.next(JSON.parse(result).map((spec: any) => {
                            return new Spec(spec);
                        }));
                    } else if (type == "specs-used") {
                        //Todo update check what is result
                        //console.log('RESULT in Storage Manager', result);
                        observer.next(JSON.parse(result).map((spec: any) => {
                            return new Spec(spec);
                        }));
                    } 
                    else if (type == "topspecs") {
                        //Todo update check what is result
                        //console.log('RESULT in Storage Manager', result);
                        observer.next(JSON.parse(result).map((spec: any) => {
                            return new Spec(spec);
                        }));
                    }
                    else {
                        observer.next(result);
                    }
                }
                observer.complete();
            });
        });
    }

    //retunr current timestamp in seconds
    getCurTS(): number {
        return moment().unix();
    }

    getKeysForStorage(type, id): Array<string> {
        let key = type + '_' + id;
        let keyExp = key + '_exp';
        return [key, keyExp];
    }

    removeAll(): void {
        if (this.DEBUG) console.log(this.TAG, 'removeAll');

        this.storage.clear().then((result) => {
            if (this.DEBUG) console.log(this.TAG, 'removeAll', result);
        });
    }

    isExpired(expTS): Observable<any> {
        return Observable.create(observer => {
            let now = this.getCurTS();
            if (now > expTS) {
                observer.next({ "expired": true, "timestamp": expTS });
            } else {
                observer.next({ "expired": false, "timestamp": expTS });
            }
            observer.complete();
        });
    }

    getExpiredFromStorage(type, id): Observable<any> {
        let keys = this.getKeysForStorage(type, id);

        return Observable.create(observer => {
            this.storage.get(keys[1]).then(expTS => {
                if (expTS !== null && expTS != 'undefined' && expTS !== undefined && expTS) {
                    this.isExpired(expTS).subscribe((isExpired) => {
                        observer.next(isExpired);
                    });
                    // let now = this.getCurTS();
                    // if (now > expTS) {
                    //   if(this.DEBUG) console.log(this.TAG, type, id, 'getExpiredFromStorage -> true');
                    //   observer.next({"expired":true,"timestamp":expTS});
                    // } else {
                    //   if(this.DEBUG) console.log(this.TAG, type, id, 'getExpiredFromStorage -> false');
                    //   observer.next({"expired":false,"timestamp":expTS});
                    // }
                } else {
                    //try to delete all data of corrupted data set
                    if (this.DEBUG) console.log(this.TAG, type, id, 'getExpiredFromStorage -> true; ' + keys[1] + ' is not availible in storage -> clean up');
                    observer.next({ "expired": true, "timestamp": 0 });
                    this.remove(type, id);
                }
                observer.complete();
            });
        });
    }
    
    async UserConsent(action): Promise<any> {
        if (this.DEBUG) console.log(this.TAG, "getUserConsent ", action);
        let result = undefined;
        switch (action) {
            case "get":
                await this.storage.get("user_consent").then((res) => {
                    if (this.DEBUG) console.log(this.TAG, "testgetUserConsent1 ", res);
                    result = res;
                });
                break;
            case "accept":
                this.storage.set("user_consent", "accept");
                result = "accept";
                break;
            case "decline":
                this.storage.set("user_consent", "decline");
                result = "decline";
                break;            
            default:
                if (this.DEBUG) console.log(this.TAG, "getUserConsent default");
                result = undefined;
                break;
        }
        return result;
    }


}
